import type { EntityCrossFilter } from './types';
import { normalizeCrossFilter } from './toggleFilter';

const STORAGE_VERSION = 2;

type StoredCrossFilter = {
  v: number;
  filter: Partial<EntityCrossFilter>;
};

function storageKey(profileId: string): string {
  return `entity-cross-filter:${profileId}`;
}

export function loadCrossFilter(profileId: string): EntityCrossFilter | null {
  if (typeof window === 'undefined' || !profileId) return null;
  try {
    const raw = window.sessionStorage.getItem(storageKey(profileId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredCrossFilter;
    // Accept v1 (entity-only) and v2 (full workspace filter); normalize missing arrays.
    if ((parsed.v !== 1 && parsed.v !== 2) || !parsed.filter) return null;
    return normalizeCrossFilter(parsed.filter);
  } catch {
    return null;
  }
}

export function saveCrossFilter(profileId: string, filter: EntityCrossFilter): void {
  if (typeof window === 'undefined' || !profileId) return;
  const payload: StoredCrossFilter = { v: STORAGE_VERSION, filter: normalizeCrossFilter(filter) };
  window.sessionStorage.setItem(storageKey(profileId), JSON.stringify(payload));
}

export function clearCrossFilterStorage(profileId: string): void {
  if (typeof window === 'undefined' || !profileId) return;
  window.sessionStorage.removeItem(storageKey(profileId));
}
